<!-- eslint-disable max-len -->
<style scoped>
  div.alert-dismissible[title='Edit Project Boundaries']{
    padding-right: 1em;
  }
  div.alert-dismissible[title='Edit Project Boundaries'] div{
    width: 320px;
  }
  div.empty{
    padding:20px;
  }
  div.sites{
    margin:0;
    padding:0;
  }
  .map-alert {
    bottom: 0px;
    left: 20px;
    position: absolute;
    z-index: 9999
  }
  .portal-item-list {
    padding: 10px;
  }
  .portal-item-label {
    padding-left: 6px;
  }
  .project-action-button {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-left: 7px;
    min-width: 100px;
  }
  .project-action-button span {
    padding-left: 5px;
  }
  .project-button-container {
    border:none !important;
    box-shadow: none !important;
  }
  .project-button-red {
    background-color: #863A21;
  }
  .project-map-overlay {
    height: 100%;
  }
  .project-pagination {
    padding:0;
    margin: 0;
  }
  .project-sites {
    margin-top: 20px;
    padding-bottom: 10px;
  }
  #esriMap {
    height: 100%;
    margin: 0;
    min-height: 517px;
    padding: 0;
    width: 100%;
  }
  #project-map .card {
    height: calc(100% - 31px);
  }
  #project-map .card-body {
    padding: 0;
  }
  #project-map .section-title.sites {
    padding-top: 10px;
    padding-bottom: 30px;
  }
</style>
<template>
  <div id="project-map">
    <div class="section-title">Project Map</div>
    <div class="card">
      <b-overlay class='project-map-overlay' :show="isSaving">
      <div class="card-body">
        <div id="esriMap">
          <b-alert class='map-alert' v-model="showManageSitesInstructions" variant="info" dismissible>
            <div>Click Sites to associate to Project.</div>
            <div>Click again to remove.</div>
            <div>Click 'Save' when done.  Click 'Cancel' to cancel.</div>
          </b-alert>
          <b-alert class='map-alert' v-model="showDrawInstructions" variant="info" dismissible>
            <div>Click in the map to draw Project boundary.</div>
            <div>Double-click to end shape drawing.</div>
            <div>Click 'Save' when done.  Click 'Cancel' to cancel.</div>
          </b-alert>
          <b-alert class='map-alert' v-model="showEditInstructions" variant="info" dismissible title='Edit Project Boundaries'>
            <div>
              <p>TO DRAW: Click 'Draw Polygon' from the toolbar, then draw the area in the map. Click 'Save' button when done.</p>
              <p>TO COPY: Open the 'Selection Layers' panel on the right and choose the selection layer. Pick shape(s) to copy in the map, click 'Set As Boundary', then click 'Save' when done.</p>
              <p>TO EDIT: To adjust a boundary, click 'Reshape' from the toolbar, select the area in the map, then click and drag boundary points. To start over, click 'Clear All' button. To delete shape(s), click the 'Trashcan' tool. To discard changes and return to view mode, click 'Cancel'.</p>
            </div>
          </b-alert>
          <b-alert class='map-alert' v-model="showEmptyProjectSitesWarning" variant="danger" dismissible>
            <div>You must map a Project area before attempting to save!</div>
          </b-alert>
          <b-alert class='map-alert' v-model="showErrorMessageAlert" variant="danger" dismissible>
            <div>{{showErrorMessageAlertBody}}</div>
          </b-alert>
          <b-alert
            :show="dismissGeocodeSuccess"
            class='map-alert'
            dismissible
            variant="success"
            @dismissed="dismissGeocodeSuccess=0"
            @dismiss-count-down="showGeocodeSuccessChanged"
          >
            <span>Project was successfully geocoded</span>
          </b-alert>
          <b-alert
            :show="dismissGeocodeWarning"
            class='map-alert'
            dismissible variant="warning"
            @dismissed="dismissGeocodeWarning=0"
            @dismiss-count-down="showGeocodeWarningChanged"
          >
            <span>The address of this Project was not available or could not be geocoded.</span>
          </b-alert>
          <b-alert
            :show="dismissGetProjectSitesWarning"
            class='map-alert'
            dismissible variant="warning"
            @dismissed="dismissGetProjectSitesWarning=0"
            @dismiss-count-down="showGetProjectSitesWarningChanged"
          >
            <div>The project sites could not be fetched from Insightly within the configured limits.</div>
            <div>Please refresh this page.</div>
          </b-alert>
        </div>
        <div style="display:none;">
          <div class='project-button-container' ref='btnDefaultButtons' v-show='btnDefaultButtonsShow && isEditable'>
            <div ref="btnManageSites" @click="btnManageSitesOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill">
              <b-icon icon="pencil"/>
              <span>Associate Sites</span>
            </div>
            <div ref="btnManageBoundaries" @click="btnManageBoundariesOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill">
              <b-icon icon="pencil"/>
              <span>Edit Project Boundaries</span>
            </div>
          </div>
          <div class='project-button-container' ref='btnManageSitesButtons' v-show='btnManageSitesButtonsShow'>
            <div ref="btnManageSitesClear" @click="btnManageSitesClearOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill project-button-red">
              <span>Clear All</span>
            </div>
            <div ref="btnManageSitesSave" @click="btnManageSitesSaveOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill">
              <span>Save Sites</span>
            </div>
            <div ref="btnManageSitesCancel" @click="btnManageSitesCancelOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill project-button-red">
              <span>Cancel</span>
            </div>
          </div>
          <div class='project-button-container' ref='btnEditButtons' v-show='btnEditCancelSaveShow'>
            <div ref="btnEditSelectBoundary" :disabled="btnEditSelectBoundaryDisabled" @click="btnEditSelectBoundaryOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill">
              <span>Set as Boundary</span>
            </div>
            <div ref="btnEditClear" @click="btnEditClearOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill project-button-red">
              <span>Clear All</span>
            </div>
            <div ref="btnEditSave" @click="btnEditSaveOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill">
              <span>Save</span>
            </div>
            <div ref="btnEditCancel" @click="btnEditCancelOnClick" class="btn project-action-button btn-primary btn-sm rounded-pill project-button-red">
              <span>Cancel</span>
            </div>
          </div>
          <div ref='portalItemList' class="esri-widget esri-widget--panel portal-item-list">
            <div v-for="(map, index) in maps" :key="map.id">
              <div v-if="index == 0">
                <input name='portalItem' type="radio" checked :value="index" @click="radioButtonOnClick"/>
                <label class="portal-item-label">{{map.title}}</label>
              </div>
              <div v-else>
                <input name='portalItem' type="radio" :value="index" @click="radioButtonOnClick"/>
                <label class="portal-item-label">{{map.title}}</label>
              </div>
            </div>
          </div>
          <div ref='selectLayerItemList' class="esri-widget esri-widget--panel portal-item-list">
            <div>
              <input name='selectLayerItem' type="radio" value="-1" v-model="selectLayerItem" @click="selectLayerItemRadioButtonOnClick"/>
              <label class="portal-item-label">(None)</label>
            </div>
            <div v-if='config && config.projectMap && config.projectMap.selectableLayers'>
              <div v-for="(selectableLayer, index) in config.projectMap.selectableLayers" :key="selectableLayer.url">
                <input name='selectLayerItem' type="radio" :value="index" v-model="selectLayerItem" @click="selectLayerItemRadioButtonOnClick"/>
                <label class="portal-item-label">{{selectableLayer.title}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      </b-overlay>
    </div>
    <div class='project-sites'>
      <div class="section-title sites">Associated Sites</div>
      <LoadingSpinner v-if='projectLoading || projectSitesLoading'
        message ='Loading Project' size = '1x'>
      </LoadingSpinner>
      <div class="card empty" v-else-if='!projectSites || projectSites.length == 0'>No sites are currently associated with this project.</div>
      <div class="card sites" v-else-if='projectSites && projectSites.length > 0'>
        <b-table
          id='projectSitesTable'
          ref='projectSitesTable'
          caption-top
          hover
          responsive
          small
          striped
          :no-provider-paging="true"
          :per-page="projectSitePerPage"
          :current-page="projectSiteCurrentPage"
          :fields="projectSiteFields"
          :items="projectSiteItems"
        >
          <template v-slot:cell(siteIdSiteName)="data">
            <router-link :to="{ name: 'Site', params: { id: data.value.siteId } }">
              {{data.value.siteName}}
            </router-link>
          </template>
        </b-table>
        <b-pagination
          class="project-pagination"
          v-model="projectSiteCurrentPage"
          align='fill'
          aria-controls="projectSitesTable"
          :total-rows="projectSiteTotalRows()"
          :per-page="projectSitePerPage"
        >
          <template v-slot:first-text><b-icon icon='caret-left-fill'/><b-icon icon='caret-left-fill'/></template>
          <template v-slot:prev-text><b-icon icon='caret-left-fill'/></template>
          <template v-slot:next-text><b-icon icon='caret-right-fill'/></template>
          <template v-slot:last-text><b-icon icon='caret-right-fill'/><b-icon icon='caret-right-fill'/></template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks */

import { mapState } from 'vuex';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import ProjectMapEventManager from '@/mixins/projectMapEventManager';
import ProjectMapLoadingManager from '@/mixins/projectMapLoadingManager';
import ProjectMapSketchManager from '@/mixins/projectMapSketchManager';

export default {
  name: 'ProjectMap',
  mixins: [ProjectApprovalMembershipManager, ProjectMapEventManager, ProjectMapLoadingManager, ProjectMapSketchManager],
  components: {
    LoadingSpinner,
  },
  computed: {
    ...mapState(['config']),
    ...mapState('Project', {
      project: (state) => state.project,
      projectLoading: (state) => state.projectLoading,
      projectSitesLoading: (state) => state.projectSitesLoading,
      projectGeometry: (state) => state.projectGeometry,
      projectSites: (state) => state.projectSites,
      successMessage: (state) => state.successMessage,
      errorMessage: (state) => state.errorMessage,
    }),
    btnEditSelectBoundaryDisabled() {
      return this.selectLayerHits.length === 0;
    },
    isEditable() {

      if (!this.project) return false;
      if (!this.config) return false;

      const isEditable = !([
        this.config.projectOverviewPage.submitStatus.Cancelled,
        this.config.projectOverviewPage.submitStatus.Completed,
      ]).includes(this.project.approvalStatus);

      return isEditable;
    },
  },
  data() {
    return {
      btnDefaultButtonsShow: true,
      btnManageSitesButtonsShow: false,
      btnEditCancelSaveShow: false,
      dismissGeocodeSuccess: 0,
      dismissGeocodeWarning: 0,
      dismissGetProjectSitesWarning: 0,
      isSaving: false,
      maps: [],
      projectSiteCurrentPage: 1,
      projectSiteFields: [
        {
          key: 'siteIdSiteName',
          label: 'Site',
        },
        {
          key: 'watershedName',
          label: 'Watershed Name',
        },
        {
          key: 'subwatershedName',
          label: 'Subwatershed Name',
        },
        {
          key: 'siteAcreage',
          label: 'Acres',
        },
      ],
      projectSitePerPage: 5,
      selectedSites: [],
      selectLayer: null,
      selectLayerId: 'projectMapSelectableLayerId',
      selectLayerItem: -1,
      selectLayerHits: [],
      showDrawInstructions: false,
      showEditInstructions: false,
      showErrorMessageAlert: false,
      showErrorMessageAlertBody: null,
      showManageSitesInstructions: false,
      showEmptyProjectSitesWarning: false,
      unsubscribeSetProject: null,
      unsubscribeSetProjectGeometry: null,
    };
  },
  mounted() {
    (async () => {

      await this.$store.dispatch('fetchConfiguration');

      this.unsubscribeSetProject = this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'Project/SET_PROJECT') {
          this.unsubscribeSetProject();
          console.debug('"Project/SET_PROJECT" mutation notification received in ProjectMap.vue');
          this.$store.dispatch('Project/getProjectSites', this.project.id);
          this.loadMap();
        }
      });

      this.unsubscribeSetProjectGeometry = this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'Project/SET_PROJECT_GEOMETRY') {
          this.unsubscribeSetProjectGeometry();
          console.debug('"Project/SET_PROJECT_GEOMETRY" mutation notification received in ProjectMap.vue');
          this.onProjectGeometrySet();
        }
      });

    })();
  },
  methods: {
    projectSiteItems() {
      const projectSiteItems = this.projectSites.map((projectSite) => {
        const site = projectSite.relatedSite;
        const item = {
          siteIdSiteName: {
            siteId: projectSite.relatedSiteId,
            siteName: site.siteName,
          },
          watershedId: site.watershedId,
          watershedName: site.watershedName,
          subwatershedId: site.subwatershedId,
          subwatershedName: site.subwatershedName,
          siteAcreage: site.siteAcreage,
        };
        return item;
      });
      return projectSiteItems;
    },
    projectSiteTotalRows() {
      return this.projectSites.length;
    },
    showGeocodeSuccess() {
      this.dismissGeocodeSuccess = 5;
    },
    showGeocodeSuccessChanged(dismissGeocodeSuccess) {
      this.dismissGeocodeSuccess = dismissGeocodeSuccess;
    },
    showGeocodeWarning() {
      if (this.project.category && this.project.category !== 'Conservation Ed Project') {
        this.dismissGeocodeWarning = 5;
      }
    },
    showGeocodeWarningChanged(dismissGeocodeWarning) {
      this.dismissGeocodeWarning = dismissGeocodeWarning;
    },
    showGetProjectSitesWarning() {
      this.dismissGetProjectSitesWarning = 5;
    },
    showGetProjectSitesWarningChanged(dismissGetProjectSitesWarning) {
      this.dismissGetProjectSitesWarning = dismissGetProjectSitesWarning;
    },
  },
};
</script>
